import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GamePage from './pages/GamePage';
import StoryPage from './pages/StoryPage';
import StoryBrowserPage from './pages/StoryBrowserPage';
import ScenarioPage from './pages/ScenarioPage';
import DualStoryPage from './pages/DualStoryPage';
import DualStoryList from './pages/DualStoryList';
import MentorStoryPage from './pages/MentorStoryPage';
import DashboardPage from './pages/DashboardPage';
import GameHistoryPage from './pages/GameHistoryPage';
import ProfilePage from './pages/ProfilePage';
import LeaderboardPage from './pages/LeaderboardPage';
import MultiplayerPage from './pages/MultiplayerPage';
import KnowledgeCardsPage from './pages/KnowledgeCardsPage';
import AntiFraudManualPage from './pages/AntiFraudManualPage';
import { StoryProvider } from './contexts/StoryContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';

const withBoundary = (node: React.ReactNode) => <ErrorBoundary>{node}</ErrorBoundary>;

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <StoryProvider>
          <Router>
            <Routes>
              <Route path="/" element={withBoundary(<HomePage />)} />
              <Route path="/game" element={withBoundary(<GamePage />)} />
              <Route path="/story" element={withBoundary(<StoryPage />)} />
              <Route path="/stories" element={withBoundary(<StoryBrowserPage />)} />
              <Route path="/story-browser" element={withBoundary(<StoryBrowserPage />)} />
              <Route path="/scenario/:scenarioId" element={withBoundary(<ScenarioPage />)} />
              <Route path="/dual-story" element={withBoundary(<DualStoryList />)} />
              <Route path="/dual-story/:id" element={withBoundary(<DualStoryPage />)} />
              <Route path="/mentor-story/:storyId" element={withBoundary(<MentorStoryPage />)} />
              <Route path="/dashboard" element={withBoundary(<DashboardPage />)} />
              <Route path="/history" element={withBoundary(<GameHistoryPage />)} />
              <Route path="/profile" element={withBoundary(<ProfilePage />)} />
              <Route path="/leaderboard" element={withBoundary(<LeaderboardPage />)} />
              <Route path="/multiplayer" element={withBoundary(<MultiplayerPage />)} />
              <Route path="/cards" element={withBoundary(<KnowledgeCardsPage />)} />
              <Route path="/manual" element={withBoundary(<AntiFraudManualPage />)} />
              {/* 兜底：未知路径回首页，避免白屏 */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </StoryProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
